import { Outlet, useParams } from 'react-router-dom';

// This component is used to ensure that the Outlet re-renders when the caseId changes.
export const OutletByCaseId = () => {
  const { caseId } = useParams();
  return <Outlet key={caseId ?? 'no-case'} />;
};
